import { store } from '@/services/store.service'
import { NostrEvent } from '@nostr/tools/wasm'
import { atom, getDefaultStore, useAtomValue } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { withAtomEffect } from 'jotai-effect'

export const pendingIdsAtom = atomWithStorage<string[]>('s:pending', [], undefined, {
  getOnInit: true
})

// events currently in the local store corresponding to pendingIdsAtom; auto-
// refetched whenever the id list changes.
export const pendingEventsAtom = withAtomEffect(atom<NostrEvent[]>([]), (get, set) => {
  const ids = get(pendingIdsAtom)
  if (ids.length === 0) {
    set(pendingEventsAtom, [])
    return
  }
  let cancelled = false
  store.queryEvents({ ids }, 5000).then((events) => {
    if (!cancelled) set(pendingEventsAtom, events)
  })
  return () => {
    cancelled = true
  }
})

const storej = getDefaultStore()

export async function savePendingEvent(event: NostrEvent) {
  await store.saveEvent(event)
  storej.set(pendingIdsAtom, (prev) => {
    if (prev.includes(event.id)) return prev
    return [event.id, ...prev]
  })
}

export async function discardPendingEvent(eventId: string) {
  await store.deleteEvents([eventId])
  storej.set(pendingIdsAtom, (prev) => prev.filter((id) => id !== eventId))
}

// hook helpers
export function usePendingIds() {
  return useAtomValue(pendingIdsAtom)
}

export function usePendingEvents() {
  return useAtomValue(pendingEventsAtom)
}
